// Created by wanwganda on 2018/12/4.
<template>
  <login @event="get" v-bind:msg="ismsg"></login>
</template>
<script>
import Login from "./components/login";
import util from "../../utils/util";
import { mapActions } from "vuex";

export default {
  data: function() {
    return {
      ismsg: false
    };
  },
  components: {
    Login
  },
  methods: {
    ...mapActions(["updateToken", "updateUid"]),
    get: function(fun) {
      this.handleSubmit(fun);
    },
    handleSubmit: function(name) {
      // 账号|account
      // logintype
      // 1、手机号验证码登录 2、邮箱验证码登陆
      // 3、手机号密码登陆 4、邮箱密码登陆 5、账号密码登陆
      //  密码|password
      // 验证码|code
      var vm = this;
      var url =
        this.urlobj.login +
        "?account=" +
        name.phoneNumber +
        "&code=" +
        name.phoneCode +
        "&logintype=1";
      this.$get(url)
        .then(resp => {
          vm.updateToken(resp.newPrimaryKeys.token);
          vm.updateUid(resp.newPrimaryKeys.uid);
          localStorage.setItem("uid",resp.newPrimaryKeys.uid)
          vm.checkManager()
        })
        .catch(error => {
          console.log(error);
        });
    },
    /* 检查用户登录信息 */
    checkManager: function() {
      var vm = this;
      var url = this.urlobj.checkManager;
      console.log(url);
      this.$get(url)
        .then(resp => {
          this.$store.commit('updateUserWorker',resp.newPrimaryKeys.userWorker)
          if (resp.newPrimaryKeys.resultStr == 0) {
            vm.$router.push("/register");
            if (!vm.$store.state.communityDetail) {
              vm.$store.state.communityDetail = {};
            }
          } else if (resp.newPrimaryKeys.resultStr == 1) {
            vm.$router.push("/auditPage");
          } else {
            
            vm.getSideBar().then(res => {
              vm.ismsg = true;
            
            
              // 正常跳转
              //判断是否为丛台区或濮阳市
              let path = resp.newPrimaryKeys.path.split('.')
              
              vm.$store.commit("updatePath", path);

              if(path.length>2 && path[2] == '410900000000'){
                //濮阳市
                vm.$store.commit("updateApptype", 'ipy');
              }else if(path.length>3 && path[3] == '130403000000'){
                //丛台区
                vm.$store.commit("updateApptype", 'ctt');
              }else if(path.length>3 && path[3] == '130423000000') {
                //临漳
                vm.$store.commit("updateApptype", 'lzt');
              } else if(path.length>=3 && path[3] == '361003000000') {
                //东乡
                vm.$store.commit("updateApptype", 'dxbst');
              }
              else{
                vm.$store.commit("updateApptype", 'mst');
              }
              vm.$store.commit("updatelocation", resp.newPrimaryKeys.coordinate);
              /*
              10000007770004        国
              10000007770005        省/直辖市
              10000007770006        市/市辖区
              10000007770007        区/县
              10000007770008        街道/乡镇
              10000007770009        社区/村
              10000007770010        网格/组
              */
              if (resp.newPrimaryKeys.level == '10000007770009' || resp.newPrimaryKeys.level == '10000007770010' ){
                console.log("社区/村 ||网格/组");
                vm.$store.commit("updateIsJiedao", 0);
              }else{
                //需要级联查询下级行政区域数据
                vm.$store.commit("updateIsJiedao", 1);
              }
              vm.$store.commit(
                "updateCommunityid",
                resp.newPrimaryKeys.communityId
              );
              vm.$store.commit(
                "updateheadpicurl",
                resp.newPrimaryKeys.headPicUrl
              );
              vm.$store.commit(
                "updateLevel",
                resp.newPrimaryKeys.level
              );
              vm.$store.commit("updateUserName", resp.newPrimaryKeys.userName);

              if (vm.$store.state.isTV == 1) {
                vm.getGongzhonghao();
                vm.$store.commit("updateinitid", resp.newPrimaryKeys.initId);
                vm.$router.push("/Shouye");
              } else if (resp.newPrimaryKeys.initId) {
                vm.getGongzhonghao();
                vm.$store.commit("updateinitid", resp.newPrimaryKeys.initId);
                // vm.$store.commit("updateNavindex", 3);
                this.$store.commit("updateChildrenInd", 0);
                this.$store.commit("updateSideIndex", 0);
                this.handleSidebarRoute()
              } else {
                vm.$store.commit("updateGZHhead", "");
                vm.$store.commit("updateGZHname", "");
                vm.$store.commit("updateinitid", "");

                // vm.$store.commit("updateNavindex", 99);
                this.$store.commit("updateChildrenInd", 0);
                this.$store.commit("updateSideIndex", 0);
                this.handleSidebarRoute()
              }
            })
          }
        })
        .catch(error => {
          vm.$Notice.error({
            desc: error
          });
          vm.loading = false;
          console.log(error);
          vm.$router.push("/");
        });
    },
    handleSidebarRoute () {
      var name = '',sideBar = JSON.parse(this.$store.state.shequSideBar)
      
      sideBar = sideBar.filter(item => item.isShow)
      if ((sideBar[0].children))  {
        name = sideBar[0].children[0].router
        sideBar[0].showChild = 1
        this.$store.commit("updateShequSideBar", JSON.stringify(sideBar));
      }
      else name = sideBar[0].router
      this.$router.push({name});
    },
    getGongzhonghao() {
      var vm = this;
      var url = this.urlobj.get;

      this.$get(url).then(res => {
        var data = res.rows[0];
        if(res.rows.length){
           this.$store.commit("updateGZHhead", data.head_img);
           this.$store.commit("updateGZHname", data.gzhmingc);
        }else{
          this.$store.commit("updateGZHhead", "");
           this.$store.commit("updateGZHname","");
        }
        // if (data.head_img) {
        //   this.$store.commit("updateGZHhead", data.head_img);
        // } else {
        //   this.$store.commit("updateGZHhead", "");
        // }
        // this.$store.commit("updateGZHname", data.gzhmingc);
      });
    },
    codeRouter() {
      var vm = this;
      // 用正则 截取 code 和 state 值  可适用于 hash 路由 和 history 模式
      var code = util.getQueryString("code");
      var istv = util.getUrlKey("state");
      console.log(code);
      console.log(istv)
      if (code) {
        if (istv == 1) {
          this.$store.commit("updateIsTv", 1);
          this.$store.commit(
            "updateNavText",
            "弘扬民族文化，学习习近平讲话，建设美好社区"
          );
          document.getElementsByTagName("body")[0].style.zoom = 0.5;
        } else {
          this.$store.commit("updateIsTv", 0);
          this.$store.commit("updateNavText", "");
        }
        /* 二维码登录 */
        var url = this.urlobj.loginByQRcode;
        this.$get(url, {
          domain:window.location.host,
          code: code,
        })
          .then(function(response) {
            if (!vm.$store.state.userInfo) {
              vm.$store.state.userInfo = {};
            }
            vm.$store.commit("updateToken", response.newPrimaryKeys.token);
            vm.$store.commit("updateUid", response.newPrimaryKeys.uid);
            localStorage.setItem("uid",response.newPrimaryKeys.uid)
            vm.checkManager()
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    getSideBar () {
      return new Promise((resolve, reject) => {
        var url = this.urlobj.getMiniSet;
        this.$get(url).then(res => {
          console.log(res)
          res.rows[0].pc.forEach(item => {
            if (item.moduleValue == "page_community_application") {
              //处理社区应用侧边菜单栏
              this.$store.commit("updateShequSideBar", JSON.stringify([]));
              let sideList = item.children?item.children.map(item => {
                let sideItem = {
                  name:item.moduleName,
                  showChild:0,
                  isShow:item.isShow?true:false,
                  id:item.id,
                  subTitle:item.subTitle,
                  router:item.page
                }
                if (item.children && item.children.length) {
                  sideItem.children = item.children.map(item => {
                    return {
                      name:item.moduleName,
                      router:item.page,
                    }
                  })
                }
                return sideItem
              }):[]
        
              this.$store.commit("updateShequSideBar", JSON.stringify(sideList));
            }
            if (item.moduleValue == "page_community_management") {
              let isShowManage = this.$store.state.userWorker == '1'?item.isShow:0;
              //let isShowManage = 1
              // if(item.isShow && item.children.length){
              //   let social_worker = item.children.filter(_item=>_item.moduleValue == 'userSocialWorker');
              //   isShowManage = social_worker.length?social_worker[0].isShow:false;
              // }
              // item.isShow = isShowManage
              //处理社区应用侧边菜单栏
           
              let sideList = item.children?item.children.map(item => {
                let sideItem = {
                  name:item.moduleName,
                  showChild:0,
                  isShow:isShowManage,
                  id:item.id,
                  subTitle:item.subTitle,
                  router:item.moduleValue
                }
                if (item.children && item.children.length) {
                  sideItem.children = item.children.map(item => {
                    return {
                      name:item.moduleName,
                      router:item.page,
                    }
                  })
                }
                return sideItem
              }):[]
              this.$store.commit("updateManagerList", sideList);
            }
          })

          //更新顶部导航栏选中
          let newNav = res.rows[0].pc.filter(item=>item.isShow)
          let navItems = []
          newNav.forEach(item => {
          if (item.moduleValue == "page_home") {
            navItems.push({
              text: item.moduleName,
              url: "/Shouye",
              type: "page_home"
            });
          } else if (item.moduleValue == "page_party") {
            navItems.push({
              text: item.moduleName,
              url: "/miniParty",
              type: "page_party"
            });
          } else if (item.moduleValue == "page_zone") {
            navItems.push({
              text: "微社区",
              url: "/miniCommunity",
              type: "page_zone"
            });
          } else if (item.moduleValue == "page_community_application") {
            navItems.push({
              text: item.moduleName,
              url: "/Shequ",
              type: "page_community_application"
            });
          } else if (item.moduleValue == "page_community_management") {
            let isShowManage = this.$store.state.userWorker == '1'?item.isShow:0;
          
            if(isShowManage){
              navItems.push({
                text: item.moduleName,
                url: "/userManager",
                type: "page_community_management"
              });
           }
            
          }
        });
        this.$store.commit("updateNavigator", JSON.stringify(navItems));
          let newNavIndex = newNav.findIndex(item=>item.moduleValue == 'page_community_application');
          this.$store.commit("updateNavindex", newNavIndex>-1?newNavIndex:0);
          
          console.log(res.rows[0].pc)
          resolve()
        })
      });
    }
  },
  created: function() {
    //在登陆页面时清除sessionStorage
    sessionStorage.clear()
  },
  mounted() {
    console.log('mounted')
    // 如果返回值包含hash code 从其他应用打开 回调会触发
    if (util.getQueryString("code")) {
      this.codeRouter()
    }
    // document.onmouseup = function() {
    //   document.onmousemove = null;
    //   if (vm.ii >= 213) {
    //     vm.ii = 213;
    //   } else {
    //     vm.ii = 0;
    //   }
    // };
  },
  /* 从本页面返回code 直接更改hash会触发 */
  beforeRouteUpdate(to, from, next) {
    console.log("beforeRouteUpdate invoked");
    this.codeRouter()
    next();
  }
};
</script>
<style scoped>
</style>
